module.exports = __webpack_public_path__ + "img/3309e85.png";